import { ReactNode, CSSProperties } from 'react';
import { DivProps } from '@/domains/global';
import { classnames } from '@/libs/utils';

/**
 * A container that will adjust to it's parent's size, maintaining the aspect ratio of the composition.
 * The parent container should have relative positioning and have a defined width and height.
 */
export const ResponsiveContainer = ({
  id,
  compositionHeight,
  compositionWidth,
  children,
  parentHeight,
  parentWidth,
  parentClassnames = '',
  childClassnames = ''
}: {
  id: string;
  compositionHeight: number;
  compositionWidth: number;
  parentHeight: CSSProperties['height'];
  parentWidth: CSSProperties['width'];
  children?: ReactNode;
  /**
   * Other optional properties
   */
  parentClassnames?: DivProps['className'];
  childClassnames?: DivProps['className'];
}) => {
  return (
    <div
      id={id}
      className={classnames('relative', parentClassnames)}
      style={{
        height: parentHeight,
        width: parentWidth
      }}
    >
      <div
        className={classnames('absolute inset-0 max-h-full max-w-full', childClassnames)}
        style={{
          aspectRatio: `${compositionWidth} / ${compositionHeight}`
        }}
      >
        {children}
      </div>
    </div>
  );
};
